import CoinStrikeLandingContent from "components/molecules/CoinStrikeLandingContent";
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";
import { useGTM } from "hooks/useGTM";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";

const CoinStrikeLandingContentContainer = () => {
  const navigate = useNavigate();
  const GTM = useGTM();
  const location = useLocation().pathname;

  const handleGetBonus = () => {
    const name = location.split("/land")[1].replace("/", "");
    GTM.clickLandGetBonus(name);
    navigate({
      search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.coinStrikeReg })}`,
    });
  };

  return <CoinStrikeLandingContent onClick={handleGetBonus} />;
};

export default CoinStrikeLandingContentContainer;
